import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  container : {display: 'flex', top: "200px", position: 'relative'},
}));

export default useStyles;